/* tslint:disable */

export class OutputData {
		Id: number;
		DecisionId: number;
		BusinessDataId: number;
		Unit: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/OutputData.ts